module.exports = __webpack_public_path__ + "static/img/wing_B740.3324573.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/wing_B740.jpg
// module id = qu6l
// module chunks = 0